import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { memo } from 'react';
import { Text } from '@portals/ui-kit';
import { EColors } from '@/_types';
import { ECardType } from '@/_components/success-stories/_types';
import { QuotesIcon } from '@/_kit/icons/quotes-icon';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'CardHeader';

type TProps = {
  cardType: ECardType;
  variant: string;
  isWhite: boolean;
  title: string;
};

export const CardHeader = memo(function Card({
  cardType,
  variant,
  isWhite,
  title,
}: TProps) {
  const translations = useTranslations();

  return (
    <div className={cn(BLOCK_NAME)}>
      {cardType !== ECardType.MORE && (
        <div className={cn(`${BLOCK_NAME}__quotes-wrapper`)}>
          <QuotesIcon className={cn(`${BLOCK_NAME}__quotes--${variant}`)} />
        </div>
      )}
      <div className={cn(`${BLOCK_NAME}__title`)}>
        <Text
          color={isWhite ? EColors.WHITE : EColors.BLACK}
          size="headline-s"
          text={translations(title)}
        />
      </div>
    </div>
  );
});
